<template>
  <div class="formulario-modelo asignacion-roles">
    <LoadingOverlay :visible="loadingInicial" message="Cargando..." />
    <LoadingOverlay :visible="loadingAccion" message="Procesando..." />

    <MensajeFlotante
      :visible="flotanteVisible"
      :mensaje="flotanteMensaje"
      :tipo="flotanteTipo"
      @cerrar="flotanteVisible = false"
    />

    <MensajeConfirmacion
      :visible="confirmVisible"
      :title="confirmTitulo"
      :message="confirmMensaje"
      :confirmText="confirmTexto"
      cancelText="Cancelar"
      @confirm="ejecutarConfirmacion"
      @cancel="confirmVisible = false"
    />

    <div class="header-flex">
      <div>
        <h1>Gestión de Usuarios</h1>
        <p class="header-sub">Administra roles, permisos y cuentas del sistema</p>
      </div>
      <div class="acciones-header">
        <button
          v-if="activeTab === 'roles' && (auth.tienePermiso('roles.gestionar'))"
          class="btn guardar"
          @click="abrirFormNuevo"
          :disabled="loadingAccion"
        >
          Nuevo rol
        </button>
        <button
          v-if="activeTab === 'usuarios' && !mostrarFormRegistro && (auth.tienePermiso('usuarios.crear'))"
          class="btn guardar"
          @click="abrirFormRegistro"
          :disabled="loadingAccion"
        >
          Registrar usuario
        </button>
        <button
          v-if="activeTab === 'permisos' && !mostrarFormPermiso && (auth.tienePermiso('permisos.asignar'))"
          class="btn guardar"
          @click="abrirFormPermisoNuevo"
          :disabled="loadingAccion"
        >
          Nuevo permiso
        </button>
      </div>
    </div>

    <div class="tabs">
      <button
        v-if="auth.tienePermiso('roles.ver')"
        class="tab-btn"
        :class="{ activa: activeTab === 'roles' }"
        @click="cambiarTab('roles')"
      >
        Roles
      </button>
      <button
        v-if="auth.tienePermiso('usuarios.ver') || auth.tienePermiso('usuarios.crear')"
        class="tab-btn"
        :class="{ activa: activeTab === 'usuarios' }"
        @click="cambiarTab('usuarios')"
      >
        Usuarios
      </button>
      <button
        v-if="auth.tienePermiso('permisos.asignar')"
        class="tab-btn"
        :class="{ activa: activeTab === 'permisos' }"
        @click="cambiarTab('permisos')"
      >
        Permisos
      </button>
    </div>

    <template v-if="activeTab === 'roles'">
      <div class="marco form-rol" v-if="mostrarFormRol">
        <h2>{{ editandoRol ? 'Editar rol' : 'Nuevo rol' }}</h2>
        <div class="divider"></div>

        <div class="formulario-inicial">
          <div class="formulario-opcion">
            <label>Nombre interno</label>
            <input
              v-model="formRol.name"
              placeholder="Ej: Evaluador"
              :disabled="!!editandoRol?.es_sistema"
            />
            <span class="nota" v-if="editandoRol?.es_sistema">
              No se puede modificar el nombre de un rol de sistema.
            </span>
          </div>
          <div class="formulario-opcion">
            <label>Etiqueta</label>
            <input v-model="formRol.label" placeholder="Ej: Evaluador de programas" />
          </div>
          <div class="formulario-opcion">
            <label>Nivel de aplicación</label>
            <select v-model="formRol.nivel_aplicacion">
              <option value="institucional">Institucional</option>
              <option value="programas">Programas</option>
              <option value="ambos">Ambos</option>
            </select>
          </div>
          <div class="formulario-opcion col-span">
            <label>Descripción <span class="nota-opt">(opcional)</span></label>
            <input v-model="formRol.descripcion" placeholder="Descripción del rol" />
          </div>
        </div>

        <div class="botones">
          <button class="btn guardar" @click="cancelarFormRol">Cancelar</button>
          <button class="btn guardar" @click="guardarRol" :disabled="loadingAccion">
            {{ loadingAccion ? 'Guardando...' : (editandoRol ? 'Actualizar' : 'Crear rol') }}
          </button>
        </div>
      </div>

      <!-- Tabla de roles -->
      <div class="marco">
        <p v-if="roles.length === 0 && !loadingInicial" class="vacio-msg">No hay roles registrados.</p>
        <table v-else class="tabla-roles">
          <thead>
            <tr>
              <th>Roles</th>
              <th>Etiqueta</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="rol in roles"
              :key="rol.id"
              :class="{ 'fila-activa': rolPermisos?.id === rol.id }"
            >
              <td class="td-name">{{ rol.name }}</td>
              <td class="td-label">{{ rol.label }}</td>
              <td class="td-acciones">
                <button v-if="auth.tienePermiso('roles.gestionar')" class="btn guardar btn-sm" @click="abrirFormEditar(rol)">Editar</button>
                <button v-if="auth.tienePermiso('roles.gestionar')" class="btn guardar btn-sm" @click="abrirPermisos(rol)">Permisos</button>
                <button
                  v-if="auth.tienePermiso('roles.gestionar')"
                  class="btn salir btn-sm"
                  @click="borrarRol(rol)"
                  :disabled="rol.es_sistema || loadingAccion"
                  :title="rol.es_sistema ? 'No se puede eliminar un rol de sistema' : ''"
                >
                  Eliminar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>

    <template v-if="activeTab === 'usuarios'">
      <div class="marco" v-if="mostrarFormRegistro">
        <h2>Registrar nuevo usuario</h2>
        <div class="divider"></div>

        <div class="formulario-inicial">
          <div class="formulario-opcion">
            <label>Nombre</label>
            <input type="text" v-model="formUsuario.name" placeholder="Nombre completo" />
          </div>
          <div class="formulario-opcion">
            <label>Correo institucional</label>
            <input type="email" v-model="formUsuario.email" placeholder="usuario@udi.edu.co" />
          </div>
          <div class="formulario-opcion">
            <label>Teléfono <span class="nota-opt">(opcional)</span></label>
            <input type="tel" v-model="formUsuario.telephone" placeholder="Ej: 3001234567" />
          </div>
        </div>

        <div class="botones">
          <button class="btn guardar" @click="cancelarFormRegistro">Cancelar</button>
          <button class="btn guardar" @click="registrar" :disabled="loadingAccion">
            {{ loadingAccion ? 'Registrando...' : 'Registrar usuario' }}
          </button>
        </div>
      </div>

      <div class="marco">
        <div class="marco-header--between">
          <h2>Usuarios registrados</h2>
          <span class="conteo" v-if="usuarios.length">
            {{ usuarios.length }} {{ usuarios.length === 1 ? 'usuario' : 'usuarios' }}
          </span>
        </div>
        <p v-if="usuarios.length === 0 && !loadingInicial" class="vacio-msg">No hay usuarios registrados.</p>
        <table v-else class="tabla-usuarios">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Correo</th>
              <th>Roles</th>
              <th>Estado</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="u in usuarios" :key="u.id">
              <td class="td-nombre">{{ u.name }}</td>
              <td class="td-correo">{{ u.email }}</td>
              <td class="td-roles">{{ rolesDeUsuario(u) }}</td>
              <td class="td-estado">
                <span
                  class="badge-estado"
                  :class="u.estado === 'inactivo' ? 'badge-estado--inactivo' : 'badge-estado--activo'"
                >
                  {{ u.estado === 'inactivo' ? 'Inactivo' : 'Activo' }}
                </span>
              </td>
              <td class="td-accion">
                <button v-if="auth.tienePermiso('usuarios.asignar_roles')" class="btn guardar btn-sm" @click="abrirModalRoles(u)" :disabled="loadingAccion">Roles</button>
                <button class="btn guardar btn-sm" @click="abrirHistorial(u)" :disabled="loadingAccion">Historial</button>
                <button v-if="auth.tienePermiso('usuarios.editar')" class="btn guardar btn-sm" @click="toggleEstado(u)" :disabled="loadingAccion">
                  {{ u.estado === 'inactivo' ? 'Activar' : 'Desactivar' }}
                </button>
                <button v-if="auth.tienePermiso('usuarios.eliminar')" class="btn salir btn-sm" @click="eliminarUsuarioAcc(u.id!)" :disabled="loadingAccion">
                  Eliminar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>

    <template v-if="activeTab === 'permisos'">
      <div class="marco form-rol" v-if="mostrarFormPermiso">
        <h2>{{ editandoPermiso ? 'Editar permiso' : 'Nuevo permiso' }}</h2>
        <div class="divider"></div>

        <div class="formulario-inicial">
          <div class="formulario-opcion">
            <label>Clave interna</label>
            <input
              v-model="formPermiso.name"
              placeholder="Ej: reportes.exportar"
              :disabled="!!editandoPermiso?.es_sistema"
            />
            <span class="nota" v-if="editandoPermiso?.es_sistema">
              No se puede modificar la clave de un permiso de sistema.
            </span>
            <span class="nota" v-else>Formato: recurso.accion en minúsculas</span>
          </div>
          <div class="formulario-opcion">
            <label>Etiqueta</label>
            <input v-model="formPermiso.label" placeholder="Ej: Exportar reportes" />
          </div>
          <div class="formulario-opcion">
            <label>Módulo</label>
            <select v-model="formPermiso.modulo_id" :disabled="!!editandoPermiso?.es_sistema">
              <option :value="null" disabled>Seleccione un módulo</option>
              <option v-for="m in modulos" :key="m.id" :value="m.id">{{ m.nombre }}</option>
            </select>
          </div>
          <div class="formulario-opcion col-span">
            <label>Descripción <span class="nota-opt">(opcional)</span></label>
            <input v-model="formPermiso.descripcion" placeholder="Descripción del permiso" />
          </div>
        </div>

        <div class="botones">
          <button class="btn guardar" @click="cancelarFormPermiso">Cancelar</button>
          <button class="btn guardar" @click="guardarPermiso" :disabled="loadingAccion">
            {{ loadingAccion ? 'Guardando...' : (editandoPermiso ? 'Actualizar' : 'Crear permiso') }}
          </button>
        </div>
      </div>

      <!-- Tabla de permisos -->
      <div class="marco">
        <p v-if="permisos.length === 0 && !loadingInicial" class="vacio-msg">No hay permisos registrados.</p>
        <table v-else class="tabla-permisos">
          <thead>
            <tr>
              <th>Clave</th>
              <th>Etiqueta</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="p in permisos" :key="p.id">
              <td class="td-pname">{{ p.name }}</td>
              <td class="td-plabel">{{ p.label }}</td>
              <td class="td-acciones">
                <button v-if="auth.tienePermiso('permisos.asignar')" class="btn guardar btn-sm" @click="abrirFormPermisoEditar(p)">Editar</button>
                <button
                  v-if="auth.tienePermiso('permisos.asignar')"
                  class="btn salir btn-sm"
                  @click="borrarPermiso(p)"
                  :disabled="p.es_sistema || loadingAccion"
                  :title="p.es_sistema ? 'No se puede eliminar un permiso de sistema' : ''"
                >
                  Eliminar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>

    <!-- Modal: Permisos del rol -->
    <div v-if="rolPermisos" class="modal-overlay">
      <div class="modal-permisos">
        <PermisosUsuario
          :id-rol="rolPermisos.id"
          :rol-label="rolPermisos.label"
          @guardado="onPermisosGuardados"
          @cerrar="cerrarPermisos"
        />
      </div>
    </div>

    <div class="modal-overlay" v-if="usuarioEditandoRoles">
      <div class="modal-panel">
        <div class="modal-header">
          <h3>Asignar roles</h3>
          <button class="btn-cerrar" @click="cerrarModalRoles" aria-label="Cerrar">✕</button>
        </div>
        <p class="modal-sub">{{ usuarioEditandoRoles.name }} · {{ usuarioEditandoRoles.email }}</p>

        <div v-if="roles.length === 0" class="vacio-msg">Cargando roles...</div>
        <div class="roles-lista" v-else>
          <label v-for="r in roles" :key="r.id" class="rol-opcion">
            <input type="checkbox" :value="r.name" v-model="rolesSeleccionados" />
            <span>{{ r.label || r.name }}</span>
          </label>
        </div>

        <div class="formulario-opcion" style="margin-top: 1rem">
          <label>Observaciones <span class="nota-opt">(opcional)</span></label>
          <input type="text" v-model="observacionesAsignacion" placeholder="Motivo del cambio" />
        </div>

        <div class="modal-footer">
          <button class="btn guardar" @click="cerrarModalRoles">Cancelar</button>
          <button class="btn guardar" @click="guardarRolesUsuario" :disabled="loadingAccion">
            {{ loadingAccion ? 'Guardando...' : 'Guardar' }}
          </button>
        </div>
      </div>
    </div>

    <div class="modal-overlay" v-if="usuarioHistorial">
      <div class="modal-panel modal-panel--wide">
        <div class="modal-header">
          <h3>Historial de roles</h3>
          <button class="btn-cerrar" @click="cerrarHistorial" aria-label="Cerrar">✕</button>
        </div>
        <p class="modal-sub">{{ usuarioHistorial.name }} · {{ usuarioHistorial.email }}</p>

        <p v-if="cargandoHistorial" class="vacio-msg">Cargando historial...</p>
        <p v-else-if="historialEntries.length === 0" class="vacio-msg">Sin historial de roles.</p>
        <table v-else class="tabla-historial">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Rol</th>
              <th>Asignado por</th>
              <th>Observaciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="entry in historialEntries" :key="entry.id">
              <td>{{ formatFecha(entry.created_at) }}</td>
              <td>{{ entry.role?.label || entry.role?.name }}</td>
              <td>{{ entry.autor?.name }}</td>
              <td>{{ entry.observaciones || '—' }}</td>
            </tr>
          </tbody>
        </table>

        <div class="modal-footer">
          <button class="btn guardar" @click="cerrarHistorial">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
/**
 * Administración de roles y matriz de permisos.
 *
 * Los roles de sistema no se pueden renombrar ni eliminar, pero sí cambiar sus
 * permisos. La lista enviada REEMPLAZA la anterior: omitir un permiso lo revoca.
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

import { ref, onMounted } from 'vue'
import useAutenticar from '@/store/IngresoAutenticar'
import LoadingOverlay from '@/components/LoadingOverlay.vue'
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import MensajeConfirmacion from '@/components/MensajeConfirmacion.vue'
import PermisosUsuario from '@/components/PermisosUsuario.vue'
import {
  listarRoles,
  crearRol,
  actualizarRol,
  eliminarRol,
  listarUsuarios,
  registrarUsuario,
  eliminarUsuario,
  actualizarEstadoUsuario,
  asignarRolesUsuario,
  historialRolesUsuario,
  listarPermisos,
  crearPermiso,
  actualizarPermiso,
  eliminarPermiso,
  listarModulos,
} from '@/services/RegistroUsuariosService'
import type { RolApi, AsignacionRolEntry, PermisoApiDetalle } from '@/services/RegistroUsuariosService'
import type { Usuario } from '@/interfaces/Usuario'
import { primerError } from '@/services/http'

const auth = useAutenticar()
const flotanteVisible = ref(false)
const flotanteMensaje = ref('')
const flotanteTipo = ref<'positivo' | 'error'>('positivo')

function mostrarExito(msg: string) {
  flotanteMensaje.value = msg
  flotanteTipo.value = 'positivo'
  flotanteVisible.value = true
}
function mostrarError(msg: string) {
  flotanteMensaje.value = msg
  flotanteTipo.value = 'error'
  flotanteVisible.value = true
}

const confirmVisible  = ref(false)
const confirmTitulo   = ref('')
const confirmMensaje  = ref('')
const confirmTexto    = ref('Confirmar')
let   confirmCallback: (() => Promise<void>) | null = null

function pedirConfirmacion(titulo: string, mensaje: string, texto: string, cb: () => Promise<void>) {
  confirmTitulo.value  = titulo
  confirmMensaje.value = mensaje
  confirmTexto.value   = texto
  confirmCallback = cb
  confirmVisible.value = true
}

async function ejecutarConfirmacion() {
  confirmVisible.value = false
  if (confirmCallback) await confirmCallback()
  confirmCallback = null
}

const loadingInicial = ref(false)
const loadingAccion = ref(false)
const activeTab = ref<'roles' | 'usuarios' | 'permisos'>('roles')

function cambiarTab(tab: 'roles' | 'usuarios' | 'permisos') {
  activeTab.value = tab
  mostrarFormRol.value = false
  editandoRol.value = null
  mostrarFormRegistro.value = false
  mostrarFormPermiso.value = false
  editandoPermiso.value = null
}

const roles = ref<RolApi[]>([])
const mostrarFormRol = ref(false)
const editandoRol = ref<RolApi | null>(null)
const formRol = ref({ name: '', label: '', descripcion: '', nivel_aplicacion: 'institucional' })
const rolPermisos = ref<RolApi | null>(null)

function abrirFormNuevo() {
  editandoRol.value = null
  formRol.value = { name: '', label: '', descripcion: '', nivel_aplicacion: 'institucional' }
  mostrarFormRol.value = true
  rolPermisos.value = null
}

function abrirFormEditar(rol: RolApi) {
  editandoRol.value = rol
  formRol.value = {
    name: rol.name,
    label: rol.label,
    descripcion: rol.descripcion ?? '',
    nivel_aplicacion: rol.nivel_aplicacion ?? 'institucional',
  }
  mostrarFormRol.value = true
  rolPermisos.value = null
}

function cancelarFormRol() {
  mostrarFormRol.value = false
  editandoRol.value = null
}

async function guardarRol() {
  if (!formRol.value.name.trim() || !formRol.value.label.trim()) {
    mostrarError('El nombre y la etiqueta son obligatorios.')
    return
  }
  loadingAccion.value = true
  const eraEdicion = !!editandoRol.value
  try {
    if (editandoRol.value) {
      const payload: { name?: string; label?: string; descripcion?: string; nivel_aplicacion?: string } = {
        label: formRol.value.label,
        nivel_aplicacion: formRol.value.nivel_aplicacion,
      }
      if (formRol.value.descripcion) payload.descripcion = formRol.value.descripcion
      if (!editandoRol.value.es_sistema) payload.name = formRol.value.name
      const result = await actualizarRol(editandoRol.value.id, payload)
      if (!result.ok) { mostrarError(primerError(result, 'Error al actualizar el rol.')); return }
    } else {
      const payload: Parameters<typeof crearRol>[0] = {
        name: formRol.value.name,
        label: formRol.value.label,
        nivel_aplicacion: formRol.value.nivel_aplicacion,
      }
      if (formRol.value.descripcion) payload.descripcion = formRol.value.descripcion
      const result = await crearRol(payload)
      if (!result.ok) { mostrarError(primerError(result, 'Error al crear el rol.')); return }
    }
    mostrarFormRol.value = false
    editandoRol.value = null
    await cargarRoles()
    mostrarExito(eraEdicion ? 'Rol actualizado correctamente.' : 'Rol creado correctamente.')
  } finally {
    loadingAccion.value = false
  }
}

function borrarRol(rol: RolApi) {
  if (rol.es_sistema) return
  pedirConfirmacion(
    'Eliminar rol',
    `¿Eliminar el rol "${rol.label}"? Esta acción no se puede deshacer.`,
    'Eliminar',
    async () => {
      loadingAccion.value = true
      const result = await eliminarRol(rol.id)
      loadingAccion.value = false
      if (!result.ok) { mostrarError(primerError(result, 'Error al eliminar el rol.')); return }
      if (rolPermisos.value?.id === rol.id) rolPermisos.value = null
      await cargarRoles()
      mostrarExito('Rol eliminado.')
    }
  )
}

function abrirPermisos(rol: RolApi) {
  rolPermisos.value = rol
  mostrarFormRol.value = false
}
function cerrarPermisos() { rolPermisos.value = null }
function onPermisosGuardados() { cerrarPermisos(); mostrarExito('Permisos actualizados correctamente.') }

const usuarios = ref<Usuario[]>([])
const mostrarFormRegistro = ref(false)
const formUsuario = ref({ name: '', email: '', telephone: '' })

const usuarioEditandoRoles = ref<Usuario | null>(null)
const rolesSeleccionados = ref<string[]>([])
const observacionesAsignacion = ref('')

const usuarioHistorial = ref<Usuario | null>(null)
const historialEntries = ref<AsignacionRolEntry[]>([])
const cargandoHistorial = ref(false)

function rolesDeUsuario(u: Usuario): string {
  const lista = u.roles ?? []
  return lista.length > 0 ? lista.map(r => r.label || r.name).join(', ') : '—'
}

function formatFecha(iso: string): string {
  try {
    return new Date(iso).toLocaleDateString('es-CO', { day: '2-digit', month: 'short', year: 'numeric' })
  } catch {
    return iso
  }
}

function abrirFormRegistro() { mostrarFormRegistro.value = true }
function cancelarFormRegistro() {
  mostrarFormRegistro.value = false
  formUsuario.value = { name: '', email: '', telephone: '' }
}

async function registrar() {
  if (!formUsuario.value.name.trim() || !formUsuario.value.email.trim()) {
    mostrarError('Nombre y correo son obligatorios.')
    return
  }
  if (!formUsuario.value.email.endsWith('@udi.edu.co')) {
    mostrarError('Solo se permiten correos @udi.edu.co.')
    return
  }
  loadingAccion.value = true
  const result = await registrarUsuario({
    name: formUsuario.value.name,
    email: formUsuario.value.email,
    ...(formUsuario.value.telephone.trim() ? { telephone: formUsuario.value.telephone } : {}),
  })
  if (!result.ok) {
    loadingAccion.value = false
    mostrarError(primerError(result, 'Error al registrar el usuario.'))
    return
  }

  // Director de Programa: asignar automáticamente el rol Docente de Calidad
  const esDirector = auth.tienePermiso('usuarios.crear') && !auth.tienePermiso('usuarios.ver')
  if (esDirector && result.data?.id) {
    const docenteRol = roles.value.find(r => r.label === 'Docente de Calidad')
    if (docenteRol) {
      await asignarRolesUsuario(result.data.id, [docenteRol.name])
    }
  }

  loadingAccion.value = false
  mostrarExito(`Usuario ${formUsuario.value.email} registrado correctamente.`)
  cancelarFormRegistro()
  await cargarUsuarios()
}

function eliminarUsuarioAcc(id: number) {
  pedirConfirmacion(
    'Eliminar usuario',
    '¿Eliminar este usuario? Esta acción no se puede deshacer.',
    'Eliminar',
    async () => {
      loadingAccion.value = true
      const result = await eliminarUsuario(id)
      loadingAccion.value = false
      if (!result.ok) { mostrarError(primerError(result, 'Error al eliminar el usuario.')); return }
      mostrarExito('Usuario eliminado.')
      await cargarUsuarios()
    }
  )
}

function toggleEstado(u: Usuario) {
  const nuevoEstado = u.estado === 'inactivo' ? 'activo' : 'inactivo'
  const accion = nuevoEstado === 'activo' ? 'Activar' : 'Desactivar'
  pedirConfirmacion(
    `${accion} usuario`,
    `¿${accion} a ${u.name}?`,
    accion,
    async () => {
      loadingAccion.value = true
      const result = await actualizarEstadoUsuario(u.id!, nuevoEstado)
      loadingAccion.value = false
      if (!result.ok) { mostrarError(primerError(result, `Error al ${accion.toLowerCase()} el usuario.`)); return }
      mostrarExito(`Usuario ${nuevoEstado === 'activo' ? 'activado' : 'desactivado'} correctamente.`)
      await cargarUsuarios()
    }
  )
}

function abrirModalRoles(u: Usuario) {
  usuarioEditandoRoles.value = u
  rolesSeleccionados.value = (u.roles ?? []).map(r => r.name)
  observacionesAsignacion.value = ''
}
function cerrarModalRoles() { usuarioEditandoRoles.value = null }

async function guardarRolesUsuario() {
  if (!usuarioEditandoRoles.value) return
  loadingAccion.value = true
  const result = await asignarRolesUsuario(
    usuarioEditandoRoles.value.id!,
    rolesSeleccionados.value,
    observacionesAsignacion.value.trim() || undefined,
  )
  loadingAccion.value = false
  if (!result.ok) { mostrarError(primerError(result, 'Error al asignar los roles.')); return }

  const idx = usuarios.value.findIndex(u => u.id === usuarioEditandoRoles.value!.id)
  if (idx !== -1) {
    const rolesAsignados = roles.value
      .filter(r => rolesSeleccionados.value.includes(r.name))
      .map(r => ({ id: r.id, name: r.name, label: r.label, nivel_aplicacion: r.nivel_aplicacion, es_sistema: r.es_sistema }))
    usuarios.value[idx] = { ...usuarios.value[idx], roles: rolesAsignados }
  }

  cerrarModalRoles()
  mostrarExito('Roles actualizados correctamente.')
  cargarUsuarios() 
}

async function abrirHistorial(u: Usuario) {
  usuarioHistorial.value = u
  historialEntries.value = []
  cargandoHistorial.value = true
  historialEntries.value = await historialRolesUsuario(u.id!)
  cargandoHistorial.value = false
}
function cerrarHistorial() { usuarioHistorial.value = null; historialEntries.value = [] }

const permisos = ref<PermisoApiDetalle[]>([])
const modulos = ref<{ id: number; nombre: string }[]>([])
const mostrarFormPermiso = ref(false)
const editandoPermiso = ref<PermisoApiDetalle | null>(null)
const formPermiso = ref({ name: '', label: '', descripcion: '', modulo_id: null as number | null })

function abrirFormPermisoNuevo() {
  editandoPermiso.value = null
  formPermiso.value = { name: '', label: '', descripcion: '', modulo_id: null }
  mostrarFormPermiso.value = true
}

function abrirFormPermisoEditar(p: PermisoApiDetalle) {
  editandoPermiso.value = p
  formPermiso.value = {
    name: p.name,
    label: p.label,
    descripcion: p.descripcion ?? '',
    modulo_id: p.modulo_id,
  }
  mostrarFormPermiso.value = true
}

function cancelarFormPermiso() {
  mostrarFormPermiso.value = false
  editandoPermiso.value = null
}

async function guardarPermiso() {
  if (!formPermiso.value.label.trim()) {
    mostrarError('La etiqueta es obligatoria.')
    return
  }
  if (!formPermiso.value.modulo_id) {
    mostrarError('Debe seleccionar un módulo.')
    return
  }
  if (!editandoPermiso.value && !formPermiso.value.name.trim()) {
    mostrarError('La clave es obligatoria.')
    return
  }
  loadingAccion.value = true
  const eraEdicion = !!editandoPermiso.value
  try {
    if (editandoPermiso.value) {
      const payload: Parameters<typeof actualizarPermiso>[1] = {
        label: formPermiso.value.label,
      }
      if (formPermiso.value.descripcion.trim()) payload.descripcion = formPermiso.value.descripcion
      if (!editandoPermiso.value.es_sistema) {
        payload.name = formPermiso.value.name
        payload.modulo_id = formPermiso.value.modulo_id!
      }
      const result = await actualizarPermiso(editandoPermiso.value.id, payload)
      if (!result.ok) { mostrarError(primerError(result, 'Error al actualizar el permiso.')); return }
    } else {
      const result = await crearPermiso({
        name: formPermiso.value.name,
        label: formPermiso.value.label,
        modulo_id: formPermiso.value.modulo_id!,
        ...(formPermiso.value.descripcion.trim() ? { descripcion: formPermiso.value.descripcion } : {}),
      })
      if (!result.ok) { mostrarError(primerError(result, 'Error al crear el permiso.')); return }
    }
    mostrarFormPermiso.value = false
    editandoPermiso.value = null
    await cargarPermisos()
    mostrarExito(eraEdicion ? 'Permiso actualizado correctamente.' : 'Permiso creado correctamente.')
  } finally {
    loadingAccion.value = false
  }
}

function borrarPermiso(p: PermisoApiDetalle) {
  if (p.es_sistema) return
  pedirConfirmacion(
    'Eliminar permiso',
    `¿Eliminar el permiso "${p.label}"? Esta acción no se puede deshacer.`,
    'Eliminar',
    async () => {
      loadingAccion.value = true
      const result = await eliminarPermiso(p.id)
      loadingAccion.value = false
      if (!result.ok) { mostrarError(primerError(result, 'Error al eliminar el permiso.')); return }
      await cargarPermisos()
      mostrarExito('Permiso eliminado.')
    }
  )
}

async function cargarRoles() { roles.value = await listarRoles() }
async function cargarUsuarios() { usuarios.value = await listarUsuarios() }
async function cargarPermisos() { permisos.value = await listarPermisos() }
async function cargarModulos() { modulos.value = await listarModulos() }

async function cargar() {
  loadingInicial.value = true
  await Promise.all([cargarRoles(), cargarUsuarios(), cargarPermisos(), cargarModulos()])
  loadingInicial.value = false
  if (!auth.tienePermiso('roles.ver')) {
    activeTab.value = 'usuarios'
  }
}

onMounted(cargar)
</script>

<style scoped>
.formulario-modelo.asignacion-roles {
  background-color: white;
  padding: 2rem;
  border-radius: var(--radius-lg);
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  box-shadow: var(--shadow-md);
  box-sizing: border-box;
  margin: 20px;
  font-family: var(--font-family);
}

.header-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.5rem;
}
.header-flex h1 {
  margin: 0;
  font-size: 1.4rem;
  font-weight: 700;
  color: #111;
}
.header-sub {
  margin: 0.2rem 0 0;
  font-size: 0.85rem;
  color: #6b7280;
}

.acciones-header {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.tabs {
  display: flex;
  border-bottom: 2px solid #e5e7eb;
  margin-bottom: 1.5rem;
}
.tab-btn {
  padding: 0.6rem 1.4rem;
  font-weight: 600;
  font-size: 0.88rem;
  font-family: var(--font-family);
  border: none;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: color 0.15s, border-color 0.15s, background 0.15s;
}
.tab-btn.activa {
  color: #0e69a0;
  border-bottom-color: #0e69a0;
}
.tab-btn:hover:not(.activa) {
  color: #374151;
  background: #f9fafb;
}

.marco {
  border: 2px solid rgb(156, 155, 155);
  box-sizing: border-box;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.5rem;
  border-radius: 4px;
}
.marco h2 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 600;
  color: #111;
}
.form-rol { background: #fafafa; }

.marco-header--between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.conteo {
  font-size: 0.75rem;
  color: #6b7280;
  background: #f1f3f5;
  padding: 4px 11px;
  border-radius: 20px;
}

.formulario-inicial {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
}
.col-span { grid-column: 1 / -1; }

.formulario-opcion {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1;
  margin-bottom: var(--space-base);
}
.formulario-opcion span.nota {
  color: #8f8e8e;
  font-size: 0.8rem;
}
.nota-opt { color: #9ca3af; font-weight: 400; }

.divider {
  border: none;
  border-bottom: 1px solid #949393;
  margin: 0;
}

label {
  display: block;
  font-weight: 500;
  font-size: var(--font-size-sm);
  color: #374151;
}

input,
select {
  padding: 0.75rem;
  min-height: 42px;
  border: 1px solid #e6e5e5;
  border-radius: 8px;
  font-size: 1rem;
  font-family: var(--font-family);
  background-color: #f9f9f9;
  box-sizing: border-box;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  width: 100%;
}
select {
  height: auto;
  line-height: 1.4;
  padding-right: 2rem;
  appearance: auto;
}
input:focus, select:focus {
  outline: none;
  border-color: #0e69a0;
  box-shadow: 0 0 0 3px rgba(14, 105, 160, 0.1);
}
input:disabled, select:disabled { opacity: 0.6; cursor: not-allowed; }
input::placeholder { color: #9ca3af; }

.botones {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 0.5rem;
}

.btn {
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  border: none;
  border-radius: var(--radius-md);
  cursor: pointer;
  height: 40px;
  font-size: var(--font-size-sm);
  font-family: var(--font-family);
  transition: all 0.15s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.btn:disabled { opacity: 0.5; cursor: not-allowed; pointer-events: none; }

.btn.guardar { background-color: #eea222; color: black; }
.btn.guardar:hover:not(:disabled) { background-color: #0e69a0; color: white; }

.btn.salir { background-color: white; border: 1px solid #ccc; color: #333; }
.btn.salir:hover:not(:disabled) { background-color: rgb(212, 26, 26); color: white; }

.btn-sm {
  padding: 0.28rem 0.7rem;
  height: auto;
  font-size: 0.78rem;
  margin-left: 4px;
}

.tabla-roles {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.92rem;
}
.tabla-roles th,
.tabla-roles td { text-align: left; padding: 0.75rem 0.6rem; }
.tabla-roles thead tr { background-color: #0e69a0; }
.tabla-roles th { font-weight: 600; color: white; font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.05em; }
.tabla-roles tbody tr { border-bottom: 1px solid #f3f4f6; transition: background 0.1s; }
.tabla-roles tbody tr:last-child { border-bottom: none; }
.tabla-roles tbody tr:hover { background: #fafafa; }
.tabla-roles tbody tr.fila-activa { background: #eff6ff; }

.td-name { font-weight: 600; color: #111; }
.td-label { color: #374151; }
.td-acciones { text-align: right; white-space: nowrap; }

.tabla-usuarios {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.92rem;
}
.tabla-usuarios th,
.tabla-usuarios td { text-align: left; padding: 0.8rem 0.75rem; }
.tabla-usuarios thead tr { background-color: #0e69a0; }
.tabla-usuarios th { font-weight: 600; color: white; font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.05em; }
.tabla-usuarios tbody tr { border-bottom: 1px solid #f3f4f6; transition: background 0.1s; }
.tabla-usuarios tbody tr:last-child { border-bottom: none; }
.tabla-usuarios tbody tr:hover { background: #fafafa; }

.td-nombre { color: #111; font-weight: 500; }
.td-correo { color: #4b5563; }
.td-roles { color: #374151; font-size: 0.88rem; }
.td-estado { text-align: center; }
.td-accion { text-align: right; white-space: nowrap; }

.badge-estado {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: 20px;
  text-transform: uppercase;
}
.badge-estado--activo { background: #d1fae5; color: #065f46; }
.badge-estado--inactivo { background: #fee2e2; color: #991b1b; }

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.48);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.modal-permisos {
  background: white;
  border-radius: 12px;
  width: 700px;
  max-width: 96vw;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}
.modal-permisos :deep(.permisos-contenido) {
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}

.modal-panel {
  background: white;
  border-radius: 12px;
  padding: 1.75rem 2rem;
  width: 100%;
  max-width: 480px;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
}
.modal-panel--wide { max-width: 680px; }

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}
.modal-header h3 { margin: 0; font-size: 1.1rem; font-weight: 700; color: #111; }

.btn-cerrar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #dde1e6;
  background: white;
  color: #555;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
  flex-shrink: 0;
}
.btn-cerrar:hover { background: rgb(212, 26, 26); color: white; border-color: rgb(212, 26, 26); }

.modal-sub { color: #6b7280; font-size: 0.85rem; margin: 0 0 1.25rem; }

.roles-lista { display: flex; flex-direction: column; gap: 0.6rem; }
.rol-opcion {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  cursor: pointer;
  font-size: 0.92rem;
  color: #111;
  font-weight: 400;
}
.rol-opcion input { cursor: pointer; accent-color: #0e69a0; width: auto; height: auto; }

.modal-footer {
  margin-top: 1.5rem;
  padding-top: 1.25rem;
  border-top: 1px solid #eef0f2;
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}

.tabla-historial {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.88rem;
  margin-top: 0.5rem;
}
.tabla-historial th,
.tabla-historial td { text-align: left; padding: 0.6rem 0.5rem; border-bottom: 1px solid #f3f4f6; }
.tabla-historial thead tr { background-color: #0e69a0; }
.tabla-historial th { font-weight: 600; color: white; font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.04em; }
.tabla-historial tbody tr:last-child td { border-bottom: none; }

.vacio-msg { color: #999; font-style: italic; margin: 0; }

.tabla-permisos {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.92rem;
}
.tabla-permisos th,
.tabla-permisos td { text-align: left; padding: 0.75rem 0.6rem; }
.tabla-permisos thead tr { background-color: #0e69a0; }
.tabla-permisos th { font-weight: 600; color: white; font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.05em; }
.tabla-permisos tbody tr { border-bottom: 1px solid #f3f4f6; transition: background 0.1s; }
.tabla-permisos tbody tr:last-child { border-bottom: none; }
.tabla-permisos tbody tr:hover { background: #fafafa; }

.td-pname { font-weight: 600; color: #111; font-family: monospace; font-size: 0.85rem; }
.td-plabel { color: #374151; }
.td-pmodulo { color: #6b7280; font-size: 0.88rem; }
.td-acciones { text-align: right; white-space: nowrap; }

.badge-tipo {
  display: inline-block;
  font-size: 0.68rem;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: 20px;
  text-transform: uppercase;
}
.badge-tipo--sistema { background: #dbeafe; color: #1d4ed8; }
.badge-tipo--custom { background: #fef3c7; color: #92400e; }

@media (max-width: 900px) {
  .formulario-inicial { grid-template-columns: 1fr; }
  .col-span { grid-column: auto; }
}
</style>
